export default __webpack_public_path__ + "static/media/banner3.8b75e86d.jpg";